/* import __COLOCATED_TEMPLATE__ from './stream.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();